import { animate } from '../../vendor/anime.esm.js';
import { DURATION, EASE, resolveDuration } from '../motion-tokens.js';

// ── JOURNEY (Track B · Ola 1.3) ───────────────────────────────────────────
// Entrada sutil del ENCABEZADO únicamente. El trazo SVG y el encendido de los
// hitos van atados al scroll en js/animations/journey-scroll.js, así que aquí
// NO tocamos .journey-route ni .journey-step (evita pelear con ese motor).
// Las 3 variantes comparten esta entrada (la diferencia visual está en layout).
export const journeyEntrance = (el) => {
    const head = el.querySelector('.journey-head');
    if (head) {
        animate(head, {
            opacity: [0, 1],
            translateY: [18, 0],
            duration: resolveDuration(DURATION.normal),
            ease: EASE.refined,
        });
    }
    return null;
};
